import server_config from './server_config.js'


export default {
  apiHttpUrl: function () {
   return server_config.api_http_url;
  },
  api_username: function () {
   return server_config.api_username;
  },
  api_password: function () {
   return server_config.api_password;
  },
  googleApiKey : function(){
    return server_config.google_api_key 
  },
  getFirebase: function () {
    return {
      apiKey: server_config.apiKey,
      authDomain: server_config.authDomain,
      projectId: server_config.projectId,
      storageBucket: server_config.storageBucket,
      messagingSenderId: server_config.messagingSenderId,
      appId: server_config.appId,
      measurementId: server_config.measurementId
    }
  },
  googleApiKeyAnalytics : function(){
    return server_config.google_analytics_api_key 
  },
  wampRealmUri : function(){
    return server_config.wamp_realm_uri 
  },
  apiWampUrl : function(){
    return server_config.api_wamp_url
  },
  tycPublicUrlAR : function(){
    return server_config.tyc_landing_url_ar
  },
  tycPublicUrlCL : function(){
    return server_config.tyc_landing_url_cl
  },
  tycPublicUrlUY : function(){
    return server_config.tyc_landing_url_uy
  }
}